import { debug, logger } from '../../utils/logger'
import { type EmbedHooks } from '.'
import playerjs from 'player.js'
import { type EmbedElementContext } from '../element-embedder'
import { isWithIFrame } from '../embed-strategies/embed-strategy'

// FIXME rollup build does not export types/*.d.ts
interface ReadyEvent {
  events: string[]
}

interface IPlayer {
  on(name: 'ready', callback: (_: ReadyEvent) => void): void
  on(name: string, callback: (_: Event) => void): void
  send(payload: { method: string, value?: any }): void
  send(payload: { method: string, value?: any }, callback: (value: any) => void): void
}
export interface PlayerJsContext {
  player: IPlayer
  events?: string[]
}
export class PlayerjsHooks implements EmbedHooks {
  onAfterCreateElement (context: EmbedElementContext): void {
    if (!isWithIFrame(context.embedTarget?.embedStrategy)) {
      logger.debug('`embedTarget.embedStrategy` does not use iframe. Player.js cannot be enabled')
      return
    }
    const iframeEl = context.embedTarget?.embedStrategy?.iFrameComponent?.iframeEl
    if (iframeEl == null) {
      logger.error('`iframeEl` is missing.')
      return
    }
    const player: IPlayer = new playerjs.Player(iframeEl) as IPlayer
    const playerjsInstance: PlayerJsContext = {
      player
    }
    context.playerjs = playerjsInstance

    player.on('ready', e => {
      context.eventEmitter.emit('playerjs.ready', playerjsInstance)
      // TODO limit events to listen
      const events = Array.isArray(e.events) ? e.events : Object.values(e.events as string)
      debug('player.js is ready', context, events)
      playerjsInstance.events = events
      // TODO limit events to listen
      events.forEach(name => {
        player.on(name, e => {
          if (context.isDebugEnabled('playerjs')) debug(`player.js received: ${name}`, e)
          context.eventEmitter.emit(`playerjs.${name}`, e)
        })
      })
    })
  }
}
